module.exports = __webpack_public_path__ + "de4dc4eb131647a69595a074b7df6902.svg";